@import '../app-brand/entities/entity-layer.module.less';
@import '../constants/spacing.module.less';

.reset-button {
  text-decoration: underline;
}

.reset-text {
  color: var(--grey-900);
}

.header-demo-banner {
  background-color: var(--green-22EE88);
  color: var(--grey-900);
  margin-bottom: @space-16;
  justify-content: center;
  padding: @space-12;

  .deactivate-button {
    text-decoration: underline;
  }
}

.deactivate-text {
  color: var(--grey-900);
}
